// @ts-nocheck
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { supabaseClient } from "@/lib/supabase/client"
import { motion } from "framer-motion"

export default function TopicsPage() {
  const [topics, setTopics] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabaseClient.from("topics").select("*").order("post_count", { ascending: false }).limit(60)
      .then(({ data }) => { setTopics(data || []); setLoading(false) })
  }, [])

  return (
    <div className="container-app py-4 pb-20 lg:pb-4">
      <div className="flex items-center gap-2 mb-4">
        <svg className="w-5 h-5 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"/>
        </svg>
        <h1 className="font-syne font-bold text-xl">Topics</h1>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {Array.from({length:9}).map((_,i) => <div key={i} className="skeleton h-20 rounded" />)}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {topics.map((t, i) => (
            <motion.div key={t.id} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.02 }}>
              <Link to={`/topics/${t.slug}`}
                className="panel p-4 flex items-center gap-3 hover:border-brand/50 transition-colors block group">
                <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 font-syne font-bold text-sm"
                  style={{ background: t.color ? t.color + "33" : "hsl(22 60% 14%)", color: t.color || "hsl(22 100% 55%)" }}>
                  t/
                </div>
                <div className="min-w-0">
                  <p className="font-bold text-sm group-hover:text-brand transition-colors truncate">t/{t.name}</p>
                  <p className="text-xs text-muted-fg">{t.post_count || 0} posts</p>
                  {t.description && <p className="text-xs text-muted-fg truncate">{t.description}</p>}
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  )
}
